/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';
import type { PurchaseItemType } from './PurchaseItemType';
import {
    PurchaseItemTypeFromJSON,
    PurchaseItemTypeFromJSONTyped,
    PurchaseItemTypeToJSON,
} from './PurchaseItemType';

/**
 * 
 * @export
 * @interface CartItem
 */
export interface CartItem {
    /**
     * 
     * @type {string}
     * @memberof CartItem
     */
    id: string;
    /**
     * the calculated id of the purchased item (either product or additional)
     * @type {string}
     * @memberof CartItem
     */
    purchasableId: string;
    /**
     * 
     * @type {string}
     * @memberof CartItem
     */
    productId: string;
    /**
     * 
     * @type {string}
     * @memberof CartItem
     */
    additionalId?: string;
    /**
     * 
     * @type {PurchaseItemType}
     * @memberof CartItem
     */
    type: PurchaseItemType;
    /**
     * 
     * @type {number}
     * @memberof CartItem
     */
    quantity: number;
    /**
     * 
     * @type {Price}
     * @memberof CartItem
     */
    price: Price;
}

/**
 * Check if a given object implements the CartItem interface.
 */
export function instanceOfCartItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "purchasableId" in value;
    isInstance = isInstance && "productId" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "quantity" in value;
    isInstance = isInstance && "price" in value;

    return isInstance;
}

export function CartItemFromJSON(json: any): CartItem {
    return CartItemFromJSONTyped(json, false);
}

export function CartItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CartItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'purchasableId': json['purchasableId'],
        'productId': json['productId'],
        'additionalId': !exists(json, 'additionalId') ? undefined : json['additionalId'],
        'type': PurchaseItemTypeFromJSON(json['type']),
        'quantity': json['quantity'],
        'price': PriceFromJSON(json['price']),
    };
}

export function CartItemToJSON(value?: CartItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'purchasableId': value.purchasableId,
        'productId': value.productId,
        'additionalId': value.additionalId,
        'type': PurchaseItemTypeToJSON(value.type),
        'quantity': value.quantity,
        'price': PriceToJSON(value.price),
    };
}

